import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRouteSnapshot, PRIMARY_OUTLET, RouterStateSnapshot, TitleStrategy } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class NestedTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    let title = this.buildTitle(snapshot);
    this.title.setTitle(title);
  }

  override buildTitle(snapshot: RouterStateSnapshot): string {
    let titles: string[] = ['Lytx Device Control Center'];
    let route: ActivatedRouteSnapshot | undefined = snapshot.root;

    while (route !== undefined) {
      let pageTitle = this.getResolvedTitleForRoute(route);

      if (pageTitle) {
        titles.push(pageTitle);
      }

      route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
    }

    return titles.reverse().join(' - ');
  }
}
